import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import { getEnvironment } from '../../../../../shared/utils/helpers';

const mutation = graphql`
  mutation MarkContractTemplateInactiveMutation($input: MarkContractTemplateInactiveInput!) {
    markContractTemplateInactive(input: $input) {
      contractTemplate {
        id
        state
      }
    }
  }
`;

const MarkContractTemplateInactiveMutation = (id, callback) => {
  const config = {
    mutation,
    variables: { input: { id } },
    onCompleted: response => {
      callback(response.markContractTemplateInactive);
    }
  };

  commitMutation(getEnvironment(), config);
};

export default MarkContractTemplateInactiveMutation;
